const config = {
    // backendUrl: 'http://localhost:5000', // Replace with your actual backend URL
    // backendUrl: 'https://j675kpch-5000.uks1.devtunnels.ms',
    backendUrl: 'https://api.strousedigital.net',
  };
  
  export default config;
  